import { DragEvent, MouseEvent, SyntheticEvent } from 'react';

export const handlerPreventAll = (e: MouseEvent | DragEvent | SyntheticEvent) => {
  e.preventDefault();
  e.stopPropagation();
};
